import {ProductAttributeType} from "../../tabs/ProductAttributes";
import {Input, Select} from "antd";
import {useContext} from "react";
import {CatalogContext} from "../../../../../providers/CatalogProvider";

type ProductAttributeValueItemProps = {
    attr: ProductAttributeType
    type: 'input' | 'select'
}

const ProductAttributeValueItem = ({attr, type}: ProductAttributeValueItemProps) => {
    const {attributes, setAttributes} = useContext(CatalogContext)

    const handleChangeValue: HandleChangeAttributeValue = (value) => {
        setAttributes(attributes.map(item => ({
            ...item,
            value: item.id === attr.id ? value : item.value,
            status: item.id === attr.id ? 'changed' : item.status,
        })))
    }

    switch (type) {
        case "input":
            return (
                <Input maxLength={40} placeholder="Value" value={attr.value as string}
                       onChange={(e) => handleChangeValue(e.target.value)}
                />
            )
        case "select":
            return (
                <Select
                    mode="tags"
                    maxTagTextLength={20}
                    maxTagCount="responsive"
                    placeholder="Values"
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    value={attr.value as string[] ?? []}
                    onChange={handleChangeValue}
                />
            )
    }
};

export default ProductAttributeValueItem;

type HandleChangeAttributeValue = (value: string | string[]) => void
